// extracted by mini-css-extract-plugin
export default {"layout":"App_layout__Asyut","main":"App_main__nhgh3","mainEditing":"App_mainEditing__ZthvN"};